<div class="dialog-header header">
  <h1>{{ data.titleQrCodeModal }}</h1>
  <button class="close-button" (click)="closeDialog()">
    <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
  </button>
</div>
<div class="dialog-content">
  <qrcode
    [qrdata]="url"
    [allowEmptyString]="false"
    [elementType]="'canvas'"
    [errorCorrectionLevel]="'M'"
    [margin]="0"
    [scale]="1"
    [width]="200"
  ></qrcode>
  <div class="url-container">
    <div class="url">{{ data.url }}</div>
    <button
      class="copy-button"
      mat-icon-button
      (click)="copyQRData()"
      id="store-badge-id"
    >
      <i class="bosch-ic bosch-ic-clickable bosch-ic-window-shuffle"></i>
    </button>
  </div>
  <h2>{{ data.descriptionQrCodeModal }}</h2>
</div>
